// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.loading[data-v-f4b50242] {\r\n  left: 0;\r\n  top: 0;\r\n  position: fixed;\r\n  padding-top: 80%;\r\n  padding-left: 42%;\n}\r\n", ""]);
// Exports
module.exports = exports;
